export default "__VITE_ASSET__BGnY40XS__"